export enum BlockExplorersEnum {
  homestead = 'https://etherscan.io/',
  goerli = 'https://goerli.etherscan.io/',
}
